<template>
  <div class="footer-buttons">
    <van-row>
      <van-col :span="span" v-for="(btn,index) in showBtns" :key="index">
        <van-button 
          :type="btn.buttonType ? btn.buttonType : (index === 0 ? 'info' : 'default')" 
          :class="[btn.className]" 
          :disabled="btn.disabled" 
          block 
          @click="btnClick(btn)"
        >{{btn.name}}</van-button>
      </van-col>
      <van-col span="6" v-if="more">
        <van-button block square  @click="actionPopup = true"><van-icon name="weapp-nav" /></van-button>
      </van-col>
    </van-row>
    <van-action-sheet v-model="actionPopup" :actions="actions" get-container="body" @select="onActionSelect" v-if="more"/>
  </div>
</template>
<script>
  export default {
    name: "footer-buttons",
    data() {
      return {
        actionPopup: false
      }
    },
    props: {
      buttons: {
        type: Array,
        default: () => {
          return []
        }
      },
      limitMore: Number
    },
    computed: {
      limit() {
        return this.limitMore > 4 ? 4 : this.limitMore;
      },
      more() {
        return this.buttons.length > this.limit
      },
      showBtns() {
        let btns = [];
        if(this.limit === 4) {
          if(this.buttons.length > this.limit) {
            btns = this.buttons.slice(0, 3);
          } else {
            btns = this.buttons.slice(0, 4);
          }
        } else {
          btns = this.buttons.slice(0, this.limit);
        }
        return btns
      },
      actions() {
        let arr = [];
        if(this.buttons.length > this.limit) {
          if(this.limit === 4) {
            arr = this.buttons.slice(3);
          } else {
            arr = this.buttons.slice(this.limit);
          }
        }
        return arr
      },

      span() {
        let span = 24;
        if(this.buttons.length <= this.limit) {
          span = 24/this.buttons.length;
        } else {
          if(this.limit === 4 && this.buttons.length > 4) {
            span = 6;
          } else {
            span = 18/this.limit;
          }
        }
        return span
      }
    },
    methods: {
      btnClick(btn) {
        this.$emit('btn-click', btn);
      },
      onActionSelect(action) {
        this.btnClick(action);
        this.actionPopup = false;
      }
    }
  };
</script>